/*
 * Copyright (c) 2023. Collabro Limited
 */
import LocationOffIcon from "@mui/icons-material/LocationOff";
import { Typography } from "@mui/material";
import noLocationsImage from "../../images/noLocations.png";

const NoLocations = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <LocationOffIcon style={{ color: "grey" }} />
      <Typography variant="subtitle1" textAlign="center">
        It seems you don't have any accessible locations in Vantage. Add them
        and they should also appear here
      </Typography>
      <img src={noLocationsImage} alt="noLocationsImage" />
    </div>
  );
};

export default NoLocations;
